import React from "react";

/**
 * 상세/등록 상단 요약 바 (제목 + 메타 + 액션 슬롯).
 */
export function DetailSummaryBar({title, meta, actions, children}) {
    return (
        <div className="detail-list-summary-bar asset-detail-summary-bar">
            <div className="detail-list-summary-main asset-detail-summary-main">
                <div className="detail-list-summary-title asset-detail-summary-title">{title}</div>
                {meta ? (
                    <div className="detail-list-summary-meta asset-detail-summary-meta">{meta}</div>
                ) : null}
                {children}
            </div>
            {actions ? (
                <div className="detail-list-summary-actions asset-detail-summary-actions">{actions}</div>
            ) : null}
        </div>
    );
}
